module.exports = __webpack_public_path__ + "static/img/banner_mb.d655838e.jpg";